import React, { useState } from 'react';

import { Row, Widget } from '@digital/ui';
import { Button, Modal } from 'antd';
import { dadosGeraisState, ordemCompraIdState, reloadDadosGeraisState, reloadState } from '../atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import { emitirContratoTotvs } from '@app/api/sas/relatorioHomologacao';
import { EStatusAprovacaoContratoTotvs } from '@app/enums';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';

const ModalEmitirPCS = () => {
    const [exibirModal, setExibirModal] = useState(false);
    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const dadosGerais = useRecoilValue(dadosGeraisState);
    const [reload, setReload] = useRecoilState(reloadState);
    const [reloadDadosGerais, setReloadDadosGerais] = useRecoilState(reloadDadosGeraisState);
    const ehAditivo = dadosGerais.tipo === ETipoDemanda.Aditivo || dadosGerais.tipo === ETipoDemanda.AditivoFaturamentoDireto;

    const onCancel = () => {
        setExibirModal(false);
    };

    const onSend = () => {
        setExibirModal(false);
        emitirContratoTotvs(ordemCompraId).then((data: any) => {
            if (data && data.valid) {
                setReload(!reload);
                setReloadDadosGerais(!reloadDadosGerais);
            }
        });
    };

    const onStart = () => {
        setExibirModal(true);
    };

    const buttons = () => {
        const actions = [];
        actions.push(
            <Button key="discordarBtn" type="danger" onClick={() => onCancel()}>
                Não
            </Button>,
        );
        actions.push(
            <Button key="concordarBtn" type="success" onClick={() => onSend()}>
                Sim
            </Button>,
        );
        return actions;
    };

    return (
        <>
            <Button onClick={() => onStart()} type="primary" className='button-sas-acoes' key="emitirPcsBtn"
                disabled={dadosGerais.contratoEmitido || dadosGerais.statusAprovacaoContratoTotvs !== EStatusAprovacaoContratoTotvs.APROVADO} >
                {`Emitir ${ehAditivo ? 'Aditivo' : ''} PCS Totvs`}
            </Button>
            <Modal
                title={`Emitir ${ehAditivo ? 'Aditivo' : ''} PCS no Totvs`}
                width="680px"
                visible={exibirModal}
                onCancel={() => onCancel()}
                footer={buttons()}>
                <Widget>
                    <Row>
                        <p style={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '50px' }}>
                            {`Tem certeza que deseja emitir o ${ehAditivo ? 'Aditivo' : ''} PCS no Totvs?`}
                        </p>
                    </Row>
                </Widget>
            </Modal>
        </>
    )
}

export default ModalEmitirPCS;
